import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "modal__under-top" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = { class: "list list--sm list--bordered" };
import { computed, ref } from "vue";
import { pluralize } from "../../../../utils";
import ModalDialog from "../../../../components/modal/ModalDialog.vue";
import ChooseGiftItem from "./ChooseGiftItem.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'GiftsModal',
    props: {
        giftable: { type: Object, required: true },
        gifts: { type: Object, required: true },
        giftsLeft: { type: Number, required: true },
        giftsUsed: { type: Number, required: true },
        vipAvailable: Boolean,
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const modal = ref();
        const availableGifts = computed(() => {
            const filtered = props.vipAvailable ? props.giftable : props.giftable.filter(gift => !gift.vip);
            return filtered.sort((a, b) => `${a.brandName} ${a.name}`.localeCompare(`${b.brandName} ${b.name}`));
        });
        const message = computed(() => {
            const message = pluralize(props.giftsLeft, 'Вам доступен <strong>%%</strong> подарок', 'Вам доступны <strong>%%</strong> подарока', 'Вам доступны <strong>%%</strong> подарков');
            if (!props.giftsUsed) {
                return message;
            }
            return `${message}, ${pluralize(props.giftsUsed, 'выбран <strong>%%</strong>', 'выбраны <strong>%%</strong>')}`;
        });
        __expose({ show });
        function show() {
            modal.value.open();
        }
        function close() {
            modal.value.close();
        }
        function onchange() {
            if (props.giftsLeft === 0) {
                setTimeout(close);
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ModalDialog, {
                id: "modal-gift-choice-active",
                title: "Доступные подарки",
                size: "lg",
                ref_key: "modal",
                ref: modal
            }, {
                under_top: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", {
                            class: "text text--md",
                            innerHTML: message.value
                        }, null, 8 /* PROPS */, _hoisted_2)
                    ])
                ]),
                main: _withCtx(() => [
                    _createElementVNode("ul", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableGifts.value, (gift, key) => {
                            return (_openBlock(), _createBlock(ChooseGiftItem, {
                                key: key,
                                gift: gift,
                                gifts: __props.gifts,
                                giftsLeft: __props.giftsLeft,
                                onChange: onchange
                            }, null, 8 /* PROPS */, ["gift", "gifts", "giftsLeft"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ]),
                _: 1 /* STABLE */
            }, 512 /* NEED_PATCH */));
        };
    }
});
